import { Directive, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

@Directive()
export abstract class BaseDestroyableComponent implements OnDestroy {
  // _componentDestroyed is LAZY: it'll be created (and allocate memory) only if you use takeUntilDestroy
  private _componentDestroyed$: Subject<void>;

  constructor() {}

  ngOnDestroy() {
    if (!this._componentDestroyed$) {
      return;
    }

    this._componentDestroyed$.next();
    this._componentDestroyed$.complete();
  }

  protected takeUntilDestroy = <T>() => {
    if (!this._componentDestroyed$) {
      this._componentDestroyed$ = new Subject<void>(); // LAZY Subject
    }

    return takeUntil<T>(this._componentDestroyed$);
  };
}
